// extracted by mini-css-extract-plugin
export default {"video":"video_video__iUw-r","playBtn":"video_playBtn__BIV0i","isPlaying":"video_isPlaying__rPdc6"};